import Tippy from '@tippyjs/react';
import { Stack } from 'react-bootstrap';
import { DetailSection } from '../../../../../../../components/generic';
import { Course } from '../../../../../../../types/course.type';

const LabelTextList = ({ label, list }: { label: string; list: string[] }) => (
  <Stack
    direction="vertical"
    gap={1}
  >
    <span
      className="fw-semibold"
      style={{ color: 'rgba(94, 100, 105, .5)' }}
    >
      {label}
    </span>
    {list.map((text, index) => (
      <span
        key={index}
        className="text-secondary fw-semibold"
      >
        {text}
      </span>
    ))}
  </Stack>
);

interface Props {
  course: Course | undefined;
}

export const SessionContactsSection = ({ course }: Props) => (
  <DetailSection title="Contacts">
    {course?.venue?.contacts?.length ? (
      course.venue.contacts.map((contact, idx) => {
        // #14: include phone_number in the rendered list when present
        const lines = [contact.email];
        if ((contact as any).phone_number) {
          lines.push((contact as any).phone_number);
        }
        return (
          <Stack
            key={idx}
            direction="horizontal"
            gap={2}
            className="align-items-start mb-2"
          >
            {contact.should_be_sent_roster && (
              <Tippy
                content="This contact should be sent the roster."
                theme="custom"
              >
                <i className="fa fa-users tippy" />
              </Tippy>
            )}
            {contact.should_be_sent_invoices && (
              <Tippy
                content="This contact should be sent the invoice."
                theme="custom"
              >
                <i className="fa fa-credit-card tippy" />
              </Tippy>
            )}
            <LabelTextList
              label={`${contact.full_name}:`}
              list={lines}
            />
          </Stack>
        );
      })
    ) : (
      <span className="fst-italic">There are no contacts to show.</span>
    )}
  </DetailSection>
);
